import { render, staticRenderFns } from "./GridTableData.vue?vue&type=template&id=7f360bb5&lang=pug"
import script from "./GridTableData.vue?vue&type=script&lang=js"
export * from "./GridTableData.vue?vue&type=script&lang=js"
import style0 from "./GridTableData.vue?vue&type=style&index=0&id=7f360bb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCard,VDataTable,VSimpleCheckbox})
